import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as QuestionMarkIcon } from '../../../assets/icons/question-mark-in-circle.svg'
import Icon from '../../../components/Icon'
import Tooltip from '../../../components/Tooltip'

import useStyles from './styles'

const HoverHelpTextIcon = ({ color, helpText, placement = 'right' }) => {
  const classes = useStyles({ color })

  // Check if helpText has structured format with description and sections
  const isStructuredHelpText = useMemo(
    () => helpText && typeof helpText === 'object' && helpText.description,
    [helpText]
  )

  const content = useMemo(() => {
    if (!helpText) return null

    if (isStructuredHelpText) {
      return (
        <div className={classes.structuredContent}>
          <div className={classes.description}>{helpText.description}</div>
          {helpText.sections?.map((section, index) => (
            <div key={`${section.title}-${index}`} className={classes.section}>
              <div className={classes.sectionTitle}>{section.title}</div>
              <div className={classes.sectionText}>{section.text}</div>
            </div>
          ))}
        </div>
      )
    }
    return helpText
  }, [isStructuredHelpText, helpText, classes])

  if (!helpText) {
    return (
      <Icon className={classes.icon}>
        <QuestionMarkIcon />
      </Icon>
    )
  }

  return (
    <Tooltip
      className={classes.tooltip}
      triggerElement={
        <Icon className={classes.icon}>
          <QuestionMarkIcon />
        </Icon>
      }
      placement={placement}
      backgroundColor="rgba(0, 0, 0, 0.8)"
      color="white"
      bodyClassName={classes.tooltipBody}
    >
      {content}
    </Tooltip>
  )
}

HoverHelpTextIcon.propTypes = {
  color: PropTypes.string,
  helpText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired
        })
      )
    })
  ]),
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
}

export default HoverHelpTextIcon
